/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { ApiKeysActions, DELETE_API_KEY_FAILURE, DELETE_API_KEY_REQUEST, DELETE_API_KEY_SUCCESS, FETCH_API_KEYS_FAILURE, FETCH_API_KEYS_REQUEST, FETCH_API_KEYS_SUCCESS, GENERATE_API_KEY_FAILURE, GENERATE_API_KEY_REQUEST, GENERATE_API_KEY_SUCCESS, REGENERATE_API_KEY_FAILURE, REGENERATE_API_KEY_REQUEST, REGENERATE_API_KEY_SUCCESS } from "../types/apiKeys"

const initialState = {
    isLoading: false,
    apiKey : {},
    apiKeys : [],
    error: '',
    generateApiKeyerror : '',
    isKeyRegenerating: false,
    regeneratedApiKey: {},
    regenerateApiKeyerror: '',

    isKeyDeleting: false,
    deleteApiKeyError: ''
}

const apiKeysReducer = (state = initialState, action: ApiKeysActions) => {
    switch (action.type) {
        case FETCH_API_KEYS_REQUEST:
            return {
                ...state,
                isLoading: true,
                apiKeys: [],
            }
        case FETCH_API_KEYS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                apiKeys: action.payload,
                error: ''
            }
        case FETCH_API_KEYS_FAILURE:
            return {
                ...state,
                isLoading: false,
                apiKeys: [],
                error: action.payload
            }
        case GENERATE_API_KEY_REQUEST:
            return {
                ...state,
                isLoading: true,
                generateApiKeyerror: ''
            }
        case GENERATE_API_KEY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                apiKey: action.payload,
                generateApiKeyerror: ''
            }
        case GENERATE_API_KEY_FAILURE:
            return {
                ...state,
                isLoading: false,
                apiKey: {},
                generateApiKeyerror: action.payload
            }
        case REGENERATE_API_KEY_REQUEST:
            return {
                ...state,
                isKeyRegenerating: true,
                regeneratedApiKey: {},
                regenerateApiKeyerror: ''
            }
        case REGENERATE_API_KEY_SUCCESS:
            return {
                ...state,
                isKeyRegenerating: false,
                regeneratedApiKey: action.payload,
                regenerateApiKeyerror: ''
            }
        case REGENERATE_API_KEY_FAILURE:
            return {
                ...state,
                isKeyRegenerating: false,
                regeneratedApiKey: {},
                regenerateApiKeyerror: action.payload
            }
        case DELETE_API_KEY_REQUEST:
            return {
                ...state,
                isKeyDeleting: true
            }
        case DELETE_API_KEY_SUCCESS:
            return {
                ...state,
                isKeyDeleting: false,
            }
        case DELETE_API_KEY_FAILURE:
            return {
                ...state,
                isKeyDeleting: false,
                deleteApiKeyError: action.payload
            }
        default: return state
    }
}

export default apiKeysReducer;
